import { useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import { dataValidator } from "../../tools/dataValidator";
import VariableDesignerSensorBatch from "./VariableDesignerSensorBatch";

import { getLabel } from "../../tools/Dictionary";
import { MdAdd, MdRemove } from "react-icons/md";

const VariableDesignerSensor = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const Data = props.Data;
  const OnSave = props.OnSave;

  //State
  const [form, setForm] = useState({
    unit: "celcius",
    row: [
      {
        temperature: 0,
        resistance: 0
      }
    ],
    tolerance: 0
  });
  const [error, setError] = useState({
  });
  const [modalBatch, setModalBatch] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  //unit
  // const listUnit = [
  //   "celsius",
  //   "fahrenheit"
  // ];

  useMount(() =>
  {

    setForm(Data);

  }, []);

/*   const onChangeUnit = (e) => {

    setForm(form => ({
      ...form,
      unit: e.target.value
    }));

    onValidateField("unit", e.target.value);

  }; */

  const onChangeTolerance = (e) => {

    setForm(form => ({
      ...form,
      tolerance: e.target.value
    }));  

    onValidateField("tolerance", e.target.value);

  }

  const onChangeRowValue = (e, _indexRow, _property) => {

    let tempRow = _.cloneDeep(form.row);

    try{

      tempRow[_indexRow][_property] = e.target.value;

      setForm(form => ({
        ...form,
        row: tempRow
      }));

      onValidateField("row", tempRow);



    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };


  // Validate field
  const onValidateField = (field = "", value = "", row = undefined) =>
  {
    let currentError = { 
      temperature: error.temperature,
      tolerance: error.tolerance
    }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    // currentField = "unit";
    // if (field == "" || field == currentField)
    // {
    //   let currentValue = field ? value : form[currentField];

    //   // Validate
    //   currentValidation = dataValidator([
    //     { field: currentField, value: currentValue, listValidation: ["required"] }
    //   ]);

    //   Validation = [...Validation, ...currentValidation];

    // }

    currentField = "tolerance"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:10", "number", "maxValue:100", "minValue:0"] }
      ]);

      Validation = [...Validation, ...currentValidation];
    }


    currentField = "row"
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];


      currentValue.forEach((c, rowIndex) => {

        if (field == "" || (c.temperature || c.temperature == 0)){

          // Validate
          currentValidation = dataValidator([
            { field: "temperature_" + rowIndex, value: c.temperature, listValidation: ["required", "max:10", "number"] }
          ]);

          Validation = [...Validation, ...currentValidation];

        }

        if (field == "" || (c.resistance || c.resistance == 0))
        {

          // Validate
          currentValidation = dataValidator([
            { field: "resistance_" + rowIndex, value: c.resistance, listValidation: ["required", "max:10", "number"] }
          ]);

          Validation = [...Validation, ...currentValidation];

        }

      });

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickAddRow = () => {

    //if (form.row.length > 99) return;

    setForm(form => ({
      ...form,
      row: [...form.row, {
        temperature: 0,
        resistance: 0  
      }]
    }));
  };

  const onClickRemoveRow = (e) =>
  {

    try
    {

      if (form.row.length <= 1) return;

      const indexRow = parseInt(e.currentTarget.dataset.row);

      setConfirm(confirm => ({
        Title: getLabel("App", "Delete"),
        Message: getLabel("VariableDesignerModal", "Are you sure you want to delete this row?"),
        Cancel: getLabel("App", "No"),
        onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
        Confirm: getLabel("App", "Yes"),
        onConfirm: () => onDeleteRow(indexRow),
        Display: true
      }));


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onDeleteRow = (_row) =>
  {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))


      let tempRow = _.cloneDeep(form.row);

      tempRow.splice(_row, 1);

      setForm(form => ({
        ...form,
        row: tempRow
      }));


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onAddInBatch = (_data) => {

    let toUpdateRow = form.row.filter(r => r.temperature);

    _data.forEach(d => {

      let indexRow = toUpdateRow.findIndex(r => r.temperature == d.temperature);

      if (indexRow > -1){

        toUpdateRow[indexRow].resistance = d.resistance;

      }else{

        toUpdateRow.push(d);

      }

    });


    toUpdateRow.sort((a, b) => {

      if (parseFloat(a.temperature) > parseFloat(b.temperature)) return 1;
      if (parseFloat(a.temperature) < parseFloat(b.temperature)) return -1;

      return 0;

    });

    setForm(form => ({
      ...form,
      row: toUpdateRow
    }));

    setModalBatch(false);


    setError({});

  };

  const onClickDeleteAll = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("VariableDesignerModal", "Are you sure you want to delete all the rows?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDeleteAll,
      Display: true
    }));

  };

  const onDeleteAll = () => {
    setConfirm(confirm => ({ ...confirm, Display: false }));

    setForm(form => ({
      ...form,
      row: [
        {
          temperature: "",
          resistance: ""
        }
      ]
    }));

  };

  const onClickSave = async () =>
  {

    try
    {

      if (!onValidateField()) throw new Error("The form contains errors. Please check and fix the fields highlighted in red.");


      OnSave(form);

      OnCloseModal();


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modalBatch && 
          <VariableDesignerSensorBatch
            OnCloseModal={() => setModalBatch(false)}
            OnConfirm={onAddInBatch}
          />
        }
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("VariableDesignerModal", "Sensor variable")}
        </div>
        <div className="page_modal_body_cont">
          {/* <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("VariableDesignerModal", "Temperature unit")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "200px" }} >
              <select
                value={form.unit}
                className={"page_select_input " + (error["unit"] ? "auth_fill_row_input_error " : "")}
                onChange={onChangeUnit}
                style={{ width: "100%", textAlign: "center", color: "black" }}
                disabled={!Access.canWrite || ReadOnly}
              >
                <option value="" hidden style={{ textAlign: "center" }}></option>
                {listUnit.map((u, index) => (
                  <option key={index} value={u} style={{ textAlign: "center", color: "black" }}>
                    {u}
                  </option>
                ))}
              </select>
              {error["unit"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["unit"]}
                </div>
              }
            </div>
          </div> */}
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("VariableDesignerModal", "Tolerance")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <div className="page_modal_body_col_value_group">
                <input
                  className={"page_text_input " + (error["tolerance"] ? "page_modal_body_col_input_error" : "")}
                  value={form.tolerance}
                  onChange={onChangeTolerance}
                  type="text"
                  style={{ width: "100px", textAlign: "center" }}
                  disabled={!Access.canWrite || ReadOnly}
                />
                &nbsp;%
              </div>
              {error["tolerance"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["tolerance"]}
                </div>
              }
            </div>
          </div>

          <div className="variabledesigner_table_cont" style={{width: "500px"}}>
            {Access.canWrite && !ReadOnly && 
              <div className="variabledesigner_table_row">
                <div className="variabledesigner_table_item" style={{ width: "100%", fontWeight: "bold" }}>
                  <input
                    type="button"
                    className="page_button"
                    value={getLabel("VariableDesigner", "Add in batch")}
                    style={{ maxWidth: "200px", marginRight: "10px" }}
                    onClick={() => setModalBatch(true)}
                  />
                  <input
                    type="button"
                    className="page_button"
                    value={getLabel("VariableDesignerModal", "Delete all")}
                    style={{ maxWidth: "200px", marginLeft: "10px", backgroundColor: "rgb(179, 0, 0)" }}
                    onClick={onClickDeleteAll}
                  />
                </div> 
              </div>
            }
            <div className="variabledesigner_table_row">
              <div className="variabledesigner_table_item" style={{ width: "40px", fontWeight: "bold" }} /> 
              <div className="variabledesigner_table_item" style={{width: "200px", fontWeight: "bold"}}> 
                Temperature (°C)
              </div>
              <div className="variabledesigner_table_item" style={{ width: "200px", fontWeight: "bold" }}>
                Resistance (KΩ)
              </div>
            </div>
            {form.row.map((row, indexRow) => (
              <div className="variabledesigner_table_row" key={indexRow}>
                <div className="variabledesigner_table_col" style={{width: "40px"}} />
                <div className="variabledesigner_table_item" style={{ width: "200px", textAlign: "center" }}>
                  <input
                    className={"page_text_input " + (error["temperature_" + indexRow] ? "page_modal_body_col_input_error" : "")}
                    value={row.temperature || ""}
                    onChange={(e) => onChangeRowValue(e, indexRow, "temperature")}
                    type="text"
                    style={{ width: "100px", textAlign: "center" }}
                    disabled={!Access.canWrite || ReadOnly}
                  />
                </div>
                <div className="variabledesigner_table_item" style={{ width: "200px", textAlign: "center" }}>
                  <input
                    className={"page_text_input " + (error["resistance_" + indexRow] ? "page_modal_body_col_input_error" : "")}
                    value={row.resistance || ""}
                    onChange={(e) => onChangeRowValue(e, indexRow, "resistance")}
                    type="text"
                    style={{ width: "100px", textAlign: "center" }}
                    disabled={!Access.canWrite || ReadOnly}
                  />
                </div>
                <div className="variabledesigner_table_col">
                  {(indexRow > 0 && Access.canWrite && !ReadOnly) &&
                  <div className="page_button_round" style={{ height: "30px", width: "30px", backgroundColor: "#b30000" }}
                    data-row={indexRow}
                    title={getLabel("VariableDesignerModal", "Remove row")} onClick={onClickRemoveRow}>
                    <MdRemove />
                  </div>
                  }
                </div>
              </div>
            ))}
            {(Access.canWrite && !ReadOnly) &&
              <div className="variabledesigner_table_row" style={{ height: "60px", marginTop: "10px", marginLeft: "20px" }}>
                <div className="page_button_round" title={getLabel("VariableDesignerModal", "Add row")} onClick={onClickAddRow}>
                  <MdAdd />
                </div>
              </div>
            }
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(!OnCloseModal) ? undefined : OnCloseModal}
          />
          {(!!Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onClickSave}
              disabled={false}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default VariableDesignerSensor